function trim(str) {
	return str.replace(/(^\s*)|(\s*$)/g, "");
}



// function get(url, data, success, dataType) {
//     ajax({
//         type : 'get',
//         url : url,
//         data : data,
//         success : success,
//         dataType : dataType
//     });
// }

function getCookie(name) {
	if (document.cookie.length > 0) {
		var arr = document.cookie.match(
			new RegExp("(^| )" + name + "=([^;]*)(;|$)")
		);
		if (arr != null) {
			return trim(arr[2]);
		}
	}
	return null;
}

function setCookie(name, value, expireSecond) {
	var exdate = new Date();
	exdate.setTime(exdate.getTime() + expireSecond * 24 * 60 * 60 * 1000);
	document.cookie =
		name +
		"=" +
		encodeURIComponent(value) +
		";expires=" +
		exdate.toUTCString() +
		";path=/;domain=jingzhi5.com";
}

function getParam(name) {
       var after = window.location.hash.split("?")[1];
        if(after){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
       var r = after.match(reg);
          if(r != null){
         return  decodeURIComponent(r[2]);
         }else{
             return null;
         }
     }
    }

function isTrue(str) {
	if (!isNaN(str) && str != "0") {
		return true
	}
}


function ajax(options) {
	//console.log(options)
	var channelId = getParam("channelId"),
		sign = getParam("sign"),
		promotionStartTime = getParam("promotionStartTime"),
		firstVisitTime = Number(
			Date.parse(new Date())
				.toString()
				.substr(0, 10)
		);
        options = options || {};
        options.type = (options.type || "GET").toUpperCase();
        options.dataType = options.dataType || "json";
        var params =formatParams(options.data);
		console.log(params)

        //创建 - 非IE6 - 第一步
        if (window.XMLHttpRequest) {
            var xhr = new XMLHttpRequest();
        } else {
            //IE6及其以下版本浏览器
            var xhr = new ActiveXObject('Microsoft.XMLHTTP');
        }

        //接收 - 第三步
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                var status = xhr.status;
                //此处不判断304，因为增加随机数后，不命中缓存
                if (status >= 200 && status < 300) {
                    options.success && options.success(xhr.responseText, xhr.responseXML);
                } else {
                    options.fail && options.fail(status);
                }
            }
        }

        //连接 和 发送 - 第二步
        if (options.type == "GET") {
			console.log(111)
            xhr.open("GET", "https://www.jingzhi5.com/novel/v2/User/click.php?channelId=" + channelId, true);
            xhr.send(null);
			
        } else if (options.type == "POST") {

            xhr.open("POST", options.url, true);
            //设置表单提交时的内容类型
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.send(params);
        }
    }
    //格式化参数
    function formatParams(data) {
        var arr = [];
        for (var name in data) {
            arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(data[name]));
        }
        //arr.push(("v=" + Math.random()).replace(".", ""));
        return arr.join("&");
    }


function setPromotionInfo() {
	var channelId = getParam("channelId"),
		sign = getParam("sign"),
		promotionStartTime = getParam("promotionStartTime"),
		firstVisitTime = Number(
			Date.parse(new Date())
				.toString()
				.substr(0, 10)
		);
	var ChannelPromotion = {
		channelId: channelId,
		sign: sign,
		promotionStartTime: promotionStartTime,
		firstVisitTime: firstVisitTime
	};
	ChannelPromotion = JSON.stringify(ChannelPromotion);
	if (channelId && sign && promotionStartTime && isTrue(channelId)) {
		setCookie(
			"ChannelPromotion",
			ChannelPromotion,
			30,
			"jingzhi5.com",
			"/"
		);
		//console.log(
		//	JSON.parse(decodeURIComponent(getCookie("ChannelPromotion"))).channelId
		//);
		//$.get("https://www.jingzhi5.com/novel/v2/User/click.php?channelId="+channelId);
		console.log(ajax())
		ajax({
			url: 'https://www.jingzhi5.com/novel/v2/User/click.php',
			type: ' GET ',
			dataType: 'json',
			data: {channelId: channelId},
			success:()=>{
				console.log("ddd")
			}
		})
		
		//.done(function() {
		//	console.log("success");
		//})
		//.fail(function() {
		//	console.log("error");
		//})
		//.always(function() {
		//	console.log("complete");
		//});


	}
	if (navigator.userAgent.indexOf("MicroMessenger") != -1) {
		var PromotionInfo = {};
		var IsVerificated = getParam("IsVerificated");
		if (IsVerificated == 3) {
			PromotionInfo.IsVerificated = IsVerificated;
			var NewPromotionInfo = JSON.stringify(PromotionInfo);
			setCookie(
				"PromotionInfo",
				NewPromotionInfo,
				3,
				"jingzhi5.com",
				"/"
			);
		}
		var DelVerificated = getParam("DelVerificated");
		if (DelVerificated == -1) {
			setCookie(
				"PromotionInfo",
				NewPromotionInfo,
				0,
				"jingzhi5.com",
				"/"
			);
		}
	}
}

function get(){
	
}

setPromotionInfo();



// WEBPACK FOOTER //
// ./src/common/setChannel.js